var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.snackbar.display)?_c('div',{staticClass:"app-snackbar",class:_vm.snackbar.mode},[_c('span',[_vm._v(_vm._s(_vm.snackbar.label))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }